module.exports = __webpack_public_path__ + "media/images/app-gallery-badge-6c9f407509135ca6dca831d2227ded63.svg";